<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="900">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <div>
                    <h4>{{ group.name }}'s Assets</h4>
                    <v-btn
                        class="me-3"
                        color="black"
                        size="small"
                        @click="addAssetDialogSwitch = true"
                    >
                        Add Asset
                    </v-btn>
                </div>
                <v-btn
                    density="compact"
                    icon="mdi-close"
                    variant="flat"
                    @click="$emit('update:modelValue', false)"
                />
            </v-card-title>

            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-table>
                            <thead>
                            <tr>
                                <th></th>
                                <th>Name</th>
                                <th>Device Serial</th>
                                <th>Asset Type</th>
                                <th v-if="user.type === 'admin'">Company</th>
                                <th class="text-end">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="asset in assets"
                                v-if="!loading && assets.length"
                                :key="asset.id"
                                class="text-left">
                                <td>
                                    <v-avatar :image="asset.asset_type.photo || defaultImage" class="mr-2" rounded="sm"
                                              size="24"/>
                                </td>
                                <td>{{ asset.label }}</td>
                                <td>{{ asset.slno }}</td>
                                <td class="text-capitalize">{{ asset.asset_type.name }}</td>
                                <td v-if="user.type === 'admin'" class="text-capitalize">
                                    {{ asset.company?.company_name }}
                                </td>
                                <td class="text-end">
                                    <v-btn-group density="compact" divided variant="outlined">
                                        <v-btn
                                            class="text-error"
                                            prepend-icon="mdi-delete"
                                            size="x-small"
                                            @click="deleteAsset(asset)"
                                        >Remove
                                        </v-btn>
                                    </v-btn-group>
                                </td>
                            </tr>
                            <tr v-else class="text-center">
                                <td v-if="loading" colspan="6">
                                    <v-progress-circular color="primary" indeterminate/>
                                </td>
                                <td v-else colspan="6">No record found</td>
                            </tr>
                            </tbody>
                        </v-table>
                    </v-col>
                </v-row>

                <v-row v-if="totalPages > 1" justify="center">
                    <v-col cols="8">
                        <v-pagination
                            v-model="currentPage"
                            :length="totalPages"
                            class="my-4"
                            density="compact"
                            @update:model-value="fetchAssets"
                        ></v-pagination>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions class="px-4 d-flex justify-end">
                <v-btn
                    size="small"
                    type="button"
                    @click="$emit('update:modelValue', false)"

                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <Add-Asset
        v-if="addAssetDialogSwitch"
        v-model="addAssetDialogSwitch"
        :group="group"
        @add-asset="updateAssets"
    />

</template>

<script setup>
import {ref, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import defaultImage from "@/assets/images/logo-1.png"
import {useSnackbarStore} from "@/stores/snackBarStore";
import AddAsset from "@/components/dialogs/assets/groups/AddAsset.vue";


const {user} = useAuthStore();
const {showSnackbar} = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    group: Object,
});

const emits = defineEmits(["update:modelValue", "newAssets"]);

const addAssetDialogSwitch = ref(false);
const dialogSwitch = ref(props.modelValue);
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const assets = ref([]);

onMounted(() => {
    fetchAssets();
});

const fetchAssets = () => {
    loading.value = true;
    send("get", `groups/assets/${props.group.id}?page=${currentPage.value}`)
        .then((response) => {
            assets.value = response.data.data.data;
            totalPages.value = response.data.data.last_page;
            currentPage.value = response.data.data.current_page;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error);
            showSnackbar("Assets could not be loaded", "error");
        });
};


const updateAssets = (selectedAssets) => {
    fetchAssets();
    emits('newAssets');
};

const deleteAsset = (asset) => {
    console.log(asset);
    if (
        confirm(`Are you sure to remove "${asset.label}" from ${props.group.name}?`)
    ) {
        send("delete", `groups/assets/${props.group.id}/${asset.id}`, null)
            .then((response) => {
                if (response.data.success) {
                    assets.value.map((item, index) => {
                        if (item.id === asset.id) {
                            assets.value.splice(index, 1);
                        }
                    });
                    emits('newAssets');
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                showSnackbar(`"${asset.name}" user could not be deleted`, "error");
            });
    }
};
</script>
